import React from 'react';
import { i18n } from '@client/const';
export function usePublicationOptionNames() {
  return React.useMemo(function () {
    var bathroom = [{
      value: '0',
      content: i18n('notSelectType')
    }, {
      value: '1',
      content: i18n('bath')
    }, {
      value: '2',
      content: i18n('shower')
    }];
    var apartmentType = [{
      value: '0',
      content: i18n('notSelectType')
    }, {
      value: '1',
      content: i18n('studio')
    }, {
      value: '2',
      content: i18n('apartment1room')
    }, {
      value: '3',
      content: i18n('apartment2room')
    }, {
      value: '4',
      content: i18n('apartment3room')
    }, {
      value: '5',
      content: i18n('apartment4room')
    }, {
      value: '6',
      content: i18n('house')
    }];
    var typePublication = [{
      value: 'SELL',
      content: i18n('sell')
    }, {
      value: 'RENT',
      content: i18n('rent')
    }];
    return {
      bathroom: bathroom,
      apartmentType: apartmentType,
      typePublication: typePublication
    };
  }, []);
}